<template>
    <b-form class="mx-4" @submit.prevent="validate" autocomplete="on">
        <b-form-group>
            <store-info />
        </b-form-group>

        <b-form-group 
            class="mt-4"
            label="Name"
            label-cols="3">
            <b-form-input
                type="text"
                name="username"
                id="username"
                v-model="$v.form.name.$model"
                :state="!$v.form.name.$invalid"
                autocomplete="on" />
            <b-form-invalid-feedback v-if="!$v.form.name.required">
                The name field is required.
            </b-form-invalid-feedback>
        </b-form-group>
      
        <b-form-group 
            label="Phone"
            label-cols="3">
            <b-form-input
                type="tel"
                name="phone"
                id="phone"
                v-model="$v.form.phone.$model"
                :state="!$v.form.phone.$invalid"
                v-mask="'+1(###) ###-####'" 
                :masked="false" 
                autocomplete="on" />
            <!-- <the-mask
                v-model="$v.form.phone.$model" 
                mask="+1(###) ###-####" 
                :class="!$v.form.phone.$invalid ? 'is-valid': 'is-invalid'"
                type="tel"
                autocomplete
                class="form-control"
            ></the-mask> -->
            <b-form-invalid-feedback v-if="!$v.form.phone.required">
                The phone number field is required.
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-else-if="!$v.form.phone.minlength">
                The phone number must be at least {{ $v.form.phone.$params.minLength.min }} digits.
            </b-form-invalid-feedback>
        </b-form-group>
       
        <b-form-group>
            <b-form-checkbox
                v-model="form.sms"
                class="float-right">
                SMS Notification
            </b-form-checkbox>
        </b-form-group> 
       
        <b-button 
            type="submit" 
            variant="primary" 
            class="start-order fill-button mt-4"
            :disabled="$v.form.$invalid" >
            Start Order
        </b-button>   
        
        <div class="row mt-2">
            <div class="col-6 pr-1">
                <b-button 
                    :variant="form.action === 'pickup' ? 'success': 'outline-success'"
                    class="fill-button"
                    @click="form.action='pickup'">
                    Pickup
                </b-button>
            </div>
            <div class="col-6 pl-1">
                <b-button 
                    :variant="form.action === 'delivery' ? 'success' : 'outline-secondary'"
                    class="fill-button"
                    @click="form.action='delivery'"
                    disabled>
                    Delivery
                </b-button>
            </div>            
        </div>
        
    </b-form>    
</template>

<script>
import { validationMixin } from 'vuelidate'
import {
    required,
    minLength
} from 'vuelidate/lib/validators'

import StoreInfo from '@/components/menu/StoreInfo'
import Swal from 'sweetalert2'
export default {
    name: 'UserInfo',
    components: { StoreInfo },
    props: [
        'user'
    ],
    computed:{        
    },
    mixins: [validationMixin],
    data() {
        return {
            form: {
                name: null,
                phone: '',
                sms: true,
                action: 'pickup'
            }
        }
    },
    validations: {
        form: {
            name: {
                required,
            },
            phone: {
                required,
                minLength: minLength(16)
            },
        }
    },
    created() {
        this.form = { ...this.user }
    },
    mounted(){
        let stringUI = this.$store.getters.getUserInfo;       
        if(stringUI !== null){
            try{                    
                let userInfo = JSON.parse(stringUI);
                this.form.name =  userInfo.name;
                this.form.phone =  userInfo.phone.replace(/ /g,'').replace(/(\d{3})(\d{3})(\d{4})/, '+1($1) $2-$3');
                this.form.sms =  userInfo.sms;
                this.form.action =  userInfo.action;       
            }catch(E){
                console.log(E);
            }                           
        } 
    },
    methods: {
        validate() {
            this.$v.form.$touch()
            if (!this.$v.form.$invalid) {
                this.saveUser()
            }
        },
        saveUser() {
            let phoneNumber = this.form.phone.replace(/\D/g, '')
            if (phoneNumber.charAt(0) == 1) phoneNumber = phoneNumber.slice(1)
            const params = {
                name: this.form.name,
                phone : phoneNumber,
                sms: this.form.sms,
                action: this.form.action,
            }
            this.$store
                .dispatch('saveUserInfo', params)
                .then(() => {
                    this.show_toast_alert("Login succeed!", 'success');
                    this.$emit('close')
                })
                .catch(() => {
                    this.show_toast_alert("Login failed!", 'error');
                })
        },
        show_toast_alert(title, status){
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                onOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            })

            Toast.fire({
                icon: status,
                title: title
            })
        },
    }
}
</script>
<style lang="scss" scoped>    
    .fill-button{
        width: -webkit-fill-available;
    }
</style>